export const defaultUrlByType = {
  Team: '/team/management',
  Avatar: '/candidate/management',
  System: '/system/manager',
};
